var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from '../../../../Components';
import styles from './styles.module.css';
import { sumSubErrors, sumSubWarnings } from './sumSubErrors';
export var RemarksView = function (_a) {
    var list = _a.list, type = _a.type;
    var dictionary = type === 'error' ? sumSubErrors : sumSubWarnings;
    return (_jsx(_Fragment, { children: list.length ? (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx("ul", __assign({ className: styles.container }, { children: list.map(function (item) { return (_jsx("li", __assign({ className: type === 'error' ? styles.error : undefined }, { children: dictionary[item] || item }), item)); }) }))] })) : null }));
};
